import React from 'react';
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Row,
  Col
} from "reactstrap";
import ImageUpload from "../../components/CustomUpload/ImageUpload.js";
const uploadmedia = () => {
  return (
    <>
      <div className='content'>
    
      <Row>
        <Col md='4' className='text-center'>
          <Card>
            <CardBody>
          <ImageUpload
          className='mt-4'
                      addBtnColor="default"
                      changeBtnColor="default"
                    />
                    </CardBody>
          </Card>
        </Col>
     
        <Col md='8'>
          <Card>
           <CardBody>
            <Row>
              <Col md='6'>
              <label>Message Text (<b>at least 2 characters</b>)*</label>
                    <FormGroup>
                      <Input type="textarea" placeholder='Enter Message' />
                    </FormGroup>
              </Col>
              <Col md='3'>
              <label>Upload </label>
              <FormGroup>
                        <Input placeholder="placeholder" type="file" style={{"opacity" : "1", "position": "initial", "border" : "solid 1px #eee"}}/>
                      </FormGroup>
              </Col>
              <Col md='3'>
              <Button className="btn-icon btn-primary btn mt-4" >
                  <i class="tim-icons icon-cloud-upload-94"></i>
                </Button>                
              </Col>
              </Row>
          </CardBody>
          </Card>
        </Col> 
      </Row>
      </div>
    </>
  )
}

export default uploadmedia
